module.exports = __webpack_public_path__ + "img/73800.844e543c.jpg";